import { render, staticRenderFns } from "./UsuarioFuncionarioForm.vue?vue&type=template&id=82d9f482&lang=html"
import script from "./UsuarioFuncionarioForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFuncionarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports